import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import { Container, Row, Card } from 'reactstrap';
import useSectors from '@/hooks/useSectors';
import styles from './styles.module.scss';
import Link from "next/link";

export const Sectors = ({
    className,
    title,
    content,
    sectors,
    heading,
    colSize = 3,
}) => {

    const items = useSectors().filter((item) => item.id !== "b31f7d16-4c46-4263-9932-f5f0f14531e2");

    const filteredItems = sectors?.length > 0 ? items.filter((sector) => sectors?.includes(sector?.id)) : items;

    if (!filteredItems || !filteredItems.length > 0) {
        return null;
    }

    return (
        <section className={`${styles.root} ${className}`}>
            <Container className="py-4 py-md-5">
                <div className="mb-5 text-center">
                    {title &&
                        <h2 className={`${heading} fw-bold`}>{title}</h2>
                    }
                    {content &&
                        <div dangerouslySetInnerHTML={{ __html: content }} />
                    }
                </div>
                <Row className="wrapper flex-wrap justify-content-center text-center">
                    {filteredItems.map((item, index) => (
                        <Card key={index} className={`bg-transparent border-0 col-12 col-md-6 col-lg-${colSize}`}>
                            <div className="mb-4 overflow-hidden rounded-4">
                                <Link href={`/sectors/${item.url_slug}`}>
                                    <a>
                                        <div className="ratio ratio-1x1">
                                            <SourceFlowImage
                                                src={item.image ? item.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                                size="500x500"
                                                alt={item?.title}
                                                className="card-img"
                                            />
                                        </div>
                                    </a>
                                </Link>
                            </div>
                            <Link href={`/sectors/${item.url_slug}`}>
                                <a>
                                    <p className="fs-5"><strong>{item?.title}</strong></p>
                                </a>
                            </Link>
                        </Card>
                    ))}
                </Row>
            </Container>
        </section>
    )
}

export default Sectors;
